import React from 'react';
import styles from './Card.module.css';

function Card({ children, title, className, style }) {
  return (
    <div className={`${styles.card} ${className || ''}`} style={style}>
      {title && <div className={styles.header}>{title}</div>}
      {children}
    </div>
  );
}

export default Card;
